import { ChangeEvent, FC, FormEvent, useState } from "react";

interface ProductGroupFormProps {
  initialValues: { itemGroupName: string };
  onSubmit: (data: { itemGroupName: string }) => void;
  onCancel: () => void;
  mode: "add" | "edit" | "view";
  loading: boolean;
}

export const ProductGroupForm: FC<ProductGroupFormProps> = ({
  initialValues,
  onSubmit,
  onCancel,
  mode,
  loading,
}) => {
  const [formData, setFormData] = useState(initialValues);

  const isViewMode = mode === "view";
  const isDisabled = isViewMode || loading;
  

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "itemGroupName" && value.length > 200) return;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (loading) return; 
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="bg-white px-6 py-12 rounded-md shadow-md my-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">
              Product Group Name*
            </label>
            <input
              type="text"
              name="itemGroupName"
              value={formData.itemGroupName}
              onChange={handleChange}
              disabled={isDisabled}
              className="w-full px-3 py-2 border rounded-md text-sm border-gray-300 disabled:bg-gray-100"
              maxLength={200}
              required
            />
          </div>
        </div>
      </div>

      {mode !== "view" && (
        <div className="flex justify-end gap-3 mt-4">
          <button
            type="button"
            onClick={onCancel}
            disabled={loading}
            className="px-6 py-2 border border-gray-300 rounded-md bg-white text-blue-600 disabled:opacity-50"
          >
            Cancel
          </button>

          <button
            type="submit"
            disabled={loading}
            className="px-6 py-2 bg-blue-600 text-white rounded-md flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {loading && (
              <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
            )}
            {mode === "add" ? "Add Item Group" : "Save Changes"}
          </button>
        </div>
      )}
    </form>
  );
};